export default __webpack_public_path__ + "static/wifi_w.ee2dd114b6e2e43bd698f3ef5ce0ccbd.svg";